import { useEffect, useState } from 'react';
import { CheckBadgeIcon } from '@heroicons/react/24/solid';
import { useSearchParams } from 'react-router-dom';
import store from '../utils/store';
import analytics from '../utils/analytics';
import { getPlanProductId, getPlanPrice, getPlanCredits } from '../utils/utils';

const addOns = [
    {
        name: 'Early renewal',
        description: `Add n credits and extend existing credits until your next renewal date`,
        price: null,
        productId: null
    },
    {
        name: '100k credits add-on',
        description: 'Add 100,000 credits to your account in the current billing cycle',
        price: 99,
        productId: 783546
    },
    {
        name: '300k credits add-on',
        description: 'Add 300,000 credits to your account in the current billing cycle',
        price: 249,
        productId: 905778
    },
    {
        name: '750k credits add-on',
        description: 'Add 750,000 credits to your account in the current billing cycle',
        price: 499,
        productId: 783531
    },
    {
        name: '2M credits add-on',
        description: 'Add 2,000,000 credits to your account in the current billing cycle',
        price: 999,
        productId: 905640
    }
]

export default function AddOns({ email, currentPlan }) {
    console.log(currentPlan);
    const [searchParams, setSearchParams] = useSearchParams();
    const [showSuccess, setShowSuccess] = useState(false);
    
    const Paddle = window.Paddle;

    useEffect(() => {
        if (searchParams.get('success') === 'true' && store.shouldShowPurchaseMessage()) {
            setShowSuccess(true);
            store.markPurchaseMessageShown();
            // Remove success param from URL without page refresh
            const newParams = new URLSearchParams(searchParams);
            newParams.delete('success');
            setSearchParams(newParams);
        }
    }, [searchParams, setSearchParams]);

    const SuccessMessage = () => (
        <div className="bg-white rounded-lg shadow-sm p-6 text-center">
            <div className="mx-auto h-12 w-12 text-green-500 mb-4">
                <CheckBadgeIcon />
            </div>
            <h2 className="text-2xl font-bold text-gray-900 mb-2">
                Purchase Successful! 🎉
            </h2>
            <p className="text-gray-500">
                Your credits have been added to your account.
            </p>
            <p className="text-sm text-gray-400 mt-8">
                To view your purchase, please refresh the page or <a href="/" className="text-mypurple hover:text-myorange">click here</a>.
            </p>
        </div>
    );

    if (showSuccess) {
        return <SuccessMessage />;
    }

    return (
        <div className="mt-8">
            <h2 className="text-2xl font-bold text-gray-900 mb-6">Add-on Credits</h2>
            <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5">
                {addOns.map((addon) => (
                    <div 
                        key={addon.name}
                        className="border border-gray-200 rounded-lg shadow-sm p-6 flex flex-col h-full"
                    >
                        <div className="flex-grow">
                            <h3 className="text-lg font-medium text-gray-900">{addon.name}</h3>
                            <p className="mt-2 mb-3 text-sm text-gray-500">
                                {addon.name === 'Early renewal' ? `Add ${getPlanCredits(currentPlan.name)} credits and extend existing credits until your next renewal date` : addon.description}
                            </p>
                        </div>
                        <div className="mt-auto">
                            {addon.price || addon.name === 'Early renewal' ? (
                                <div className="mb-4">
                                    <span className="text-2xl font-bold text-gray-900">
                                        ${addon.name === 'Early renewal' ? getPlanPrice(currentPlan.name) : addon.price}
                                    </span>
                                </div>
                            ) : null}
                            <button
                                disabled={!email}
                                onClick={() => {
                                    Paddle.Checkout.open({
                                        product: addon.name === 'Early renewal' 
                                            ? getPlanProductId(currentPlan.name) 
                                            : addon.productId,
                                        email,
                                        success: 'https://console.unwrangle.com/billing?success=true',
                                        passthrough: 'user-initiated'
                                    });
                                    analytics.track('Click buy addon', {
                                        'addon': addon.name
                                    });
                                }}
                                className="w-full hover:bg-gray-900 hover:text-white border border-gray-900 rounded-md py-2 text-sm font-semibold text-gray-900 text-center bg-gray-100"
                            >
                                Buy Now
                            </button>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
}
